/*
 * サブシステム名：マスタ管理
 * 機能名：発着地マスタ一覧
 */

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'MstHacchakuchiList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      hacchakuchiCd: '',
      hacchakuchiNm: '',
      torihikisakiCd: ''
    },
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki'
    }),
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredMstTorihikisakiList () {
      // 全取引先表示
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstHacchekuchiList.defineHeaderPromise')
            this.headers = [
              { text: '操作', value: 'actions', sortable: false, width: '20px' },
              { text: '発着地コード', value: 'hacchakuchiCd' },
              { text: '発着地名称', value: 'hacchakuchiNm' },
              { text: '発着地名称カナ', value: 'hacchakuchiNmKana' },
              { text: '発着地グループコード', value: 'hacchakuchiGroupCd' },
              { text: '取引先名称', value: 'torihikisakiNm' },
              { text: '取引先担当者', value: 'torihikisakiTantosha' },
              { text: '郵便番号', value: 'yubinNo' },
              { text: '住所', value: 'jusho' },
              { text: '電話番号', value: 'telNo' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            this.conditions = {
              hacchakuchiCd: '',
              hacchakuchiNm: '',
              torihikisakiCd: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstHacchekuchiList.savedInputRestorePromise', c)
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('MstHacchekuchiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstHacchekuchiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // this.search().then(() => {
            //  resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstHacchekuchiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstHacchekuchiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstHacchakuchi/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('MstHacchekuchiList.clearInputsPromise')
            this.conditions = {
              hacchakuchiCd: '',
              hacchakuchiNm: '',
              torihikisakiCd: ''
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            this.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
